import { FailureSeverity } from '../types/FailureSeverity';
import { ValidationFailure } from '../types/ValidationFailure';

export const createUnexpectedValidationFailure = (): ValidationFailure => ({
  message: 'Unexpected error happened.',
  code: 'UNEXPECTED_ERROR',
  severity: FailureSeverity.Error,
});
